(() => {
  const root = document.querySelector('.custom-tpt-root');
  if (!root) return;
  const keys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','gbraid','wbraid'];
  const current = new URL(location.href);
  root.querySelectorAll('a[data-offer],a[data-brand],a[href*="view=custom-tpt-"]').forEach(link => {
    const url = new URL(link.href);
    // Keep new hidden-page previews on their own page when switching offer views.
    if (url.searchParams.has("view") && current.searchParams.has("preview_key")) {
      url.pathname = current.pathname;
      url.searchParams.set("preview_key", current.searchParams.get("preview_key"));
    } else if (url.searchParams.has("view") && current.pathname.startsWith("/pages/tpt-new-sell-your-")) {
      url.pathname = current.pathname;
    }
    if (url.origin === current.origin && current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    keys.forEach(key => { if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key)); });
    link.href = url.href;
  });
  // Native independent details panels match the reference's FAQ behavior.
  const mobileActions = root.querySelector('.custom-mobile-actions');
  if (mobileActions) {
    const syncMobileActions = () => mobileActions.classList.toggle('custom-is-visible', window.scrollY > 300);
    window.addEventListener('scroll', syncMobileActions, {passive:true});
    syncMobileActions();
  }
  // The team remains natively swipeable even without JavaScript.
  const teamTrack = root.querySelector('#custom-tpt-team-track');
  if (teamTrack) {
    const cards = Array.from(teamTrack.querySelectorAll('.custom-team-portrait'));
    const controls = root.querySelector('#custom-tpt-team-controls');
    const previous = root.querySelector('#custom-tpt-team-previous');
    const next = root.querySelector('#custom-tpt-team-next');
    const position = root.querySelector('#custom-tpt-team-position');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const geometry = () => {
      const gap = parseFloat(window.getComputedStyle(teamTrack).columnGap) || 0;
      const stride = cards[0].getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.floor((teamTrack.clientWidth + gap + 1) / stride));
      const first = Math.max(0, Math.min(cards.length - visible, Math.round(teamTrack.scrollLeft / stride)));
      return {stride, visible, first, max:Math.max(0, teamTrack.scrollWidth - teamTrack.clientWidth)};
    };
    const syncTeam = () => {
      const {visible, first, max} = geometry();
      previous.disabled = teamTrack.scrollLeft <= 2;
      next.disabled = teamTrack.scrollLeft >= max - 2;
      const end = Math.min(first + visible, cards.length);
      position.textContent = `${first + 1}${end > first + 1 ? `–${end}` : ''} of ${cards.length}`;
      controls.hidden = max <= 2;
    };
    const moveTeam = (amount, edge) => {
      const {stride, first, max} = geometry();
      const left = edge === 'start' ? 0 : edge === 'end' ? max : Math.max(0, Math.min(max, (first + amount) * stride));
      teamTrack.scrollTo({left, behavior:motion.matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => moveTeam(-geometry().visible));
    next.addEventListener('click', () => moveTeam(geometry().visible));
    teamTrack.addEventListener('keydown', event => {
      if (event.target !== teamTrack) return;
      if (event.key === 'ArrowLeft') moveTeam(-1);
      else if (event.key === 'ArrowRight') moveTeam(1);
      else if (event.key === 'Home') moveTeam(0, 'start');
      else if (event.key === 'End') moveTeam(0, 'end');
      else return;
      event.preventDefault();
    });
    teamTrack.addEventListener('scroll', syncTeam, {passive:true});
    window.addEventListener('resize', syncTeam, {passive:true});
    if (window.ResizeObserver) new window.ResizeObserver(syncTeam).observe(teamTrack);
    syncTeam();
  }
  const frame = root.querySelector('#custom-tpt-seller-form');
  if(frame){
    const confirmation = root.querySelector('#custom-tpt-inquiry-confirmation');
    const inquiry = root.querySelector('#custom-tpt-inquiry-content');
    const loading = root.querySelector('#custom-tpt-form-loading');
    const allowedOrigins = new Set(['https://form.jotform.com','https://submit.jotform.com']);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let completed = false;
    const showConfirmation = (preview = false) => {
      if (completed || !confirmation || !inquiry) return;
      completed = true;
      inquiry.hidden = true;
      confirmation.hidden = false;
      root.classList.add('custom-is-submitted');
      const heading = root.querySelector('#custom-tpt-offer-title');
      const intro = root.querySelector('#custom-tpt-offer-intro');
      heading.textContent = preview ? 'Thank-you page preview.' : 'Thank you. You’re in good hands.';
      intro.textContent = preview ? 'A preview of the completion screen for your review.' : 'Your inquiry has been submitted. Here’s what happens next.';
      if (preview) {
        root.querySelector('#custom-tpt-confirmation-preview-notice').hidden = false;
        root.querySelector('#custom-tpt-confirmation-status').textContent = 'Confirmation design preview';
        root.querySelector('#custom-tpt-confirmation-description').textContent = 'After a successful submission, this screen explains the next steps: a review of the watch details and a conversation with the TPT team.';
        document.title = 'Thank-you Preview | Timepiece Trading';
      } else {
        document.title = 'Inquiry Submitted | Timepiece Trading';
        confirmation.focus({preventScroll:true});
        confirmation.scrollIntoView({block:'start',behavior:reduceMotion?'auto':'smooth'});
      }
    };
    // Explicit, labeled visual preview only. Never used as proof of submission.
    if (current.searchParams.get('preview') === 'thank-you') {
      showConfirmation(true);
      return;
    }
    const url = new URL(frame.dataset.src);
    const model = current.searchParams.get('model');
    if(model) {
      const selected = model.slice(0,180);
      url.searchParams.set('typeA',selected);
      const modelNote = root.querySelector('#custom-tpt-selected-model');
      if (modelNote) { modelNote.textContent = `Selected watch: ${selected}. You can edit this in the form.`; modelNote.hidden = false; }
    }
    keys.forEach(key=>{if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));});
    const fallback = root.querySelector('#custom-tpt-form-direct');
    if(fallback) { const direct = new URL(url); direct.searchParams.delete('isIframeEmbed'); fallback.href = direct.href; }
    if (loading) loading.hidden = false;
    // An iframe load means only that navigation finished, never submission success.
    frame.addEventListener('load',() => { if (loading) loading.hidden = true; });
    window.addEventListener('message',event => {
      if (!allowedOrigins.has(event.origin) || event.source !== frame.contentWindow) return;
      const data = event.data;
      // Jotform's built-in Thank You message. Retain its native redirect as fallback.
      // The existing external redirect setting must be verified before launch.
      if (data && typeof data === 'object' && data.action === 'submission-completed' && data.formID === frame.dataset.formId) {
        showConfirmation();
        return;
      }
      if (typeof data !== 'string' || completed) return;
      const parts=event.data.split(':');
      if(parts[0]==='setHeight'){
        const height=Number(parts[1]);
        if(Number.isFinite(height)&&height>=120&&height<=6000)frame.style.height=`${Math.round(height)}px`;
      }
      if(parts[0]==='scrollIntoView')frame.scrollIntoView({block:'start',behavior:reduceMotion?'auto':'smooth'});
    });
    if (frame.src !== url.href) frame.src = url.href;
  }
})();
